import React from 'react';
import { ChatInterface } from '@/components/chat/ChatInterface';

export function ChatPage() {
  return (
    <div className="space-y-6" data-testid="chat-page">
      <div>
        <h1 className="font-heading font-bold text-3xl tracking-tight">
          CHAT INTERFACE
        </h1>
        <p className="text-muted-foreground mt-1">
          Interact with Ellie's tiered inference system
        </p>
      </div>

      <div className="max-w-4xl">
        <ChatInterface />
      </div>
    </div>
  );
}

export default ChatPage;
